// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FormRoot-module__FormRoot__EgVdN {
    width: 100%;
}

.FormRoot-module__FullHeight__Ry_Fp {
    height: 100%;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"FormRoot": `FormRoot-module__FormRoot__EgVdN`,
	"FullHeight": `FormRoot-module__FullHeight__Ry_Fp`
};
export default ___CSS_LOADER_EXPORT___;
